import { render, staticRenderFns } from "./ModalConfigServiceForDoctor.vue?vue&type=template&id=21b15e4b&scoped=true"
import script from "./ModalConfigServiceForDoctor.vue?vue&type=script&lang=js"
export * from "./ModalConfigServiceForDoctor.vue?vue&type=script&lang=js"
import style0 from "./ModalConfigServiceForDoctor.vue?vue&type=style&index=0&id=21b15e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b15e4b",
  null
  
)

export default component.exports